import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, withRouter } from "react-router-dom";

import {
  Container,
  Wrapper,
  Title,
  Bold,
  Copy,
  Spinner,
  InternalImage,
  Row,
  Button
} from "app/NativeComponents/common";
import { Loading } from "app/NativeComponents/website/common";
import {
  loadSignUpOnboarding,
  getUser,
  appRedirect,
  startRedirect
} from "app/NativeActions";

import Register from "app/DealMachineCore/components/Register";
import VerifyEmail from "app/DealMachineCore/components/VerifyEmail";
import VerifyPhone from "app/DealMachineCore/components/VerifyPhone";

import SelectPlans from "app/DealMachineCore/components/SelectPlans";
import ConfirmPayment from "app/DealMachineCore/components/ConfirmPayment";

import OnboardingText from "app/DealMachineCore/snippets/OnboardingText";

import PartnerLogos from "app/NativeComponents/website/snippets/PartnerLogos";

class SignUpContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onboarding_content: null,
      onboarding_content_loading: true,
      signup_sidebar_slug: null
    };
  }

  componentDidMount() {
    const token = window.localStorage.getItem("token");
    if (token != null) {
      this.props.getUser({
        token,
        device: this.props.device,
        redirect: true
      });
    }

    this.getOnboardingData();
  }

  determineSidebarSlug(user_info, onboarding_content) {
    if (onboarding_content && onboarding_content.signUpSidebarOptions) {
      for (let i = 0; i < onboarding_content.signUpSidebarOptions.length; i++) {
        if (!!user_info.promoText) {
          if (
            "signup_sidebar_" + user_info.promoText.toLowerCase() ==
            onboarding_content.signUpSidebarOptions[i]
          ) {
            return onboarding_content.signUpSidebarOptions[i];
          }
        }
      }

      for (let i = 0; i < onboarding_content.signUpSidebarOptions.length; i++) {
        if (!!user_info.signup_engine) {
          if (
            "signup_sidebar_" + user_info.signup_engine.toLowerCase() ==
            onboarding_content.signUpSidebarOptions[i]
          ) {
            return onboarding_content.signUpSidebarOptions[i];
          }
        }
      }
    }

    return "signup_sidebar_default";
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.onboarding_content &&
      (this.props.user_info?.promo != prevProps.user_info?.promo ||
        this.props.user_info?.engine_slug != prevProps.user_info?.engine_slug ||
        this.state.onboarding_content !== prevState.onboarding_content)
    ) {
      this.setState({
        signup_sidebar_slug: this.determineSidebarSlug(
          this.props.user_info,
          this.state.onboarding_content
        )
      });
    }
  }

  getOnboardingData(signup_slug) {
    loadSignUpOnboarding("new_onboarding")
      .then(data => {
        if (data && data.items && data.items.length > 0) {
          this.setState(() => ({
            onboarding_content: data.items[0]
              ? data.items[0].fields
                ? data.items[0].fields
                : null
              : null,
            onboarding_content_loading: false
          }));
        }
        this.setState(() => ({ onboarding_content_loading: false }));
      })
      .catch(err => {
        this.setState(() => ({ onboarding_content_loading: false }));
      });
  }

  renderTitle() {
    const { onboarding_content } = this.state;
    const { colors } = this.props;

    if (onboarding_content && onboarding_content.sidebarTitle) {
      return (
        <Title
          style={{
            color: colors.white_text_color,
            textAlign: "center"
          }}
        >
          {onboarding_content.sidebarTitle}
        </Title>
      );
    }
  }

  renderTitleBold() {
    const { onboarding_content } = this.state;
    const { colors } = this.props;

    if (onboarding_content && onboarding_content.sidebarTitleBold) {
      return (
        <Title
          style={{
            color: colors.white_text_color,
            textAlign: "center"
          }}
        >
          <Bold>{onboarding_content.sidebarTitleBold}</Bold>
        </Title>
      );
    }
  }

  renderDescription() {
    const { onboarding_content } = this.state;
    const { colors } = this.props;

    if (onboarding_content && onboarding_content.sidebarText) {
      return (
        <Copy
          style={{
            color: colors.white_text_color,
            textAlign: "center"
          }}
        >
          {onboarding_content.sidebarText}
        </Copy>
      );
    }
  }

  renderBold() {
    const { onboarding_content } = this.state;
    const { colors } = this.props;

    if (onboarding_content && onboarding_content.sidebarBold) {
      return (
        <Copy
          style={{
            color: colors.white_text_color,
            textAlign: "center"
          }}
        >
          <Bold>{onboarding_content.sidebarBold}</Bold>
        </Copy>
      );
    }
  }

  renderIcon() {
    if (this.props.signUpMobile && this.props.device === "desktop") {
      return (
        <Wrapper
          style={{
            padding: 40,
            paddingBottom: 0,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <PartnerLogos is_white={false} size={60} />
        </Wrapper>
      );
    }
  }

  renderContainer() {
    if (this.props.init && this.props.user) {
      return (
        <div id="deal-signup-container">
          {this.renderIcon()}
          <Route exact path="/sign-up" component={Register} />
          <Route
            exact
            path="/sign-up/verify-email-address"
            component={VerifyEmail}
          />
          <Route
            exact
            path="/sign-up/verify-phone-number"
            component={VerifyPhone}
          />

          <Route exact path="/sign-up/select-option" component={SelectPlans} />
          <Route
            exact
            path="/sign-up/confirm-payment"
            component={ConfirmPayment}
          />
        </div>
      );
    } else if (this.props.loading) {
      return <Spinner />;
    } else {
      return (
        <div id="deal-signup-container">
          {this.renderIcon()}
          <Route exact path="/sign-up" component={Register} />
        </div>
      );
    }
  }

  render() {
    return (
      <div className="dm-app-wrapper">
        <div id="deal-sign-up-sidebar">
          <PartnerLogos is_white={true} size={100} />

          <Wrapper>
            <OnboardingText
              slug={this.state.signup_sidebar_slug}
              largeImage={true}
              center={true}
              whiteText={true}
              style={{
                padding: 0
              }}
              innerStyle={{}}
            />
          </Wrapper>

          <div />
        </div>
        {this.renderContainer()}
      </div>
    );
  }
}

const mapStateToProps = ({ auth, settings, native, marketing }) => {
  const { token, user, init, loading } = auth;

  const { colors } = settings;
  const { isMobile, signUpMobile, device } = native;
  const { user_info } = marketing;

  return {
    token,
    user,
    init,
    loading,
    colors,
    isMobile,
    signUpMobile,
    device,
    user_info
  };
};

export default withRouter(
  connect(mapStateToProps, { getUser, appRedirect, startRedirect })(
    SignUpContainer
  )
);
